module.exports = __webpack_public_path__ + "13_hair_black.6c8f79c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/13_hair_black.png
// module id = DdNG
// module chunks = 0